import React from 'react';

import Input from './../Input';

const Name = (props) => (
    <Input label="课程名称" name="courseName" {...props}></Input>
);

export default Name;